import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import domtoimage from 'dom-to-image';

@Injectable()
export class ImgService {

    constructor(
        private httpClient: HttpClient
    ) { }

    getImageMultipartFile(node: any, name: string) {
        return new Promise<any>((resolve, reject) => {
            domtoimage.toPng(node)
                .then(dataUrl => {
                    let img = new Image();
                    img.src = dataUrl;
                    resolve(img.src);
                })
                .catch(error => reject(error));
        });
    }

    private b64toArrayBuffer(dataURI) {
        const byteString = atob(dataURI.split(',')[1]);
        const ab = new ArrayBuffer(byteString.length);
        const ia = new Uint8Array(ab);
        for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }
        return ia;
    }


    private b64toBlob(dataURI, mimetype) {
        return new Blob([this.b64toArrayBuffer(dataURI)], {
            type: mimetype
        });
    }
}


// WEBPACK FOOTER //
// /src/pages/apps/gamer/services/img.service.ts